import { render, staticRenderFns } from "./hotSaleListReport.vue?vue&type=template&id=b2eabfa0&scoped=true&"
import script from "./hotSaleListReport.vue?vue&type=script&lang=js&"
export * from "./hotSaleListReport.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleListReport.vue?vue&type=style&index=0&id=b2eabfa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eabfa0",
  null
  
)

export default component.exports